import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=474e7e52&scoped=true"
import script from "./candidate.vue?vue&type=script&lang=js"
export * from "./candidate.vue?vue&type=script&lang=js"
import style0 from "./candidate.vue?vue&type=style&index=0&id=474e7e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e7e52",
  null
  
)

export default component.exports